import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";


export default class MessagePopup extends Popup
{
    // #region Attributes //

    // private:

    private _message: string = null;
    private _isCloseBtn: boolean = null;

    // #endregion //


    public set message( value: string ) { this._message = value; }
    public set isCloseBtn( value: boolean ) { this._isCloseBtn = value; }


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        if ( this._isCloseBtn === null )
        {
            this._isCloseBtn = true;
        }

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.popup_base.texture );
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 );
        this._root.addChild( base );

        let messageText: PIXI.Text = new PIXI.Text( this._message, { 
            fontFamily: "asap_regular", 
            fontSize: 38, 
            fill: 0xffffdf,
            wordWrap: true,
            wordWrapWidth: ServiceLocator.app.width * 0.8,
            align: "center" } );
        messageText.anchor.set( 0.5 );
        messageText.position.set( base.texture.width * 0.5, 194 );
        base.addChild( messageText );

        if ( this._isCloseBtn )
        {
            let closeBtn: Button = new Button( { on: "popup_button_green" } );
            closeBtn.anchor.set( 0.5 );
            closeBtn.position.set( base.texture.width * 0.5, 350 );
            base.addChild( closeBtn );
            closeBtn.on( "pointertap", () => { this._onClosed.dispatch( this ); } );
            //
            let text: PIXI.Text = new PIXI.Text( "CONTINUE", { 
                fontFamily: "asap_extrabold", 
                fontSize: 30, 
                fill: 0xffffdf } );
            text.anchor.set( 0.5 );
            closeBtn.addChild( text );
        }
        else
        {
            messageText.y = base.texture.height * 0.5;
        }
    }

    // #endregion //
}